import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsWorkWithFriendsV2Enabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.WORK_WITH_FRIENDS_V2, {
    defaultValue: false,
  });
}
